import capitalize from "lodash/capitalize";
import Emojify from "~/components/shared/Emojify";
import * as React from "react";
import { JobStates } from "~/components/build/Show/lib/types";
import Duration from "~/components/shared/Duration";
import { LimitingJob } from "~/components/job/Job/shared/types";

const STATE_TO_TEXT: Partial<Record<JobStates, string>> = {
  scheduled: "Waiting for agent",
  platform_limiting: "Waiting on platform limits",
  platform_limited: "Waiting on platform limits",
  limited: "Waiting on concurrency group",
  assigned: "Waiting to accept",
  accepted: "Accepted",
  running: "Running",
  canceling: "Canceling",
  timing_out: "Timing out",
};

export function JobRow({ job }: { job: LimitingJob | null }) {
  if (job === null) {
    return (
      <li className="monospace m-0 border-gray-300 p-2.5 text-xs">A job owned by another team</li>
    );
  }

  const stateText = STATE_TO_TEXT[job.state] || capitalize(job.state);

  const duration = job.currentStateSince ? (
    <>
      {" "}
      <Duration.Short from={job.currentStateSince} />
    </>
  ) : null;

  return (
    <li className="monospace m-0 border-gray-300 p-2.5 text-xs">
      <a href={job.webUrl}>
        <Emojify text={job.name} />
        <span className="dark-gray"> in </span>
        <Emojify text={job.pipelineName} />
        {` `}
        <span className="dark-gray">#{job.buildNumber}</span>
      </a>{" "}
      ({stateText}
      {duration})
    </li>
  );
}
